// assets/customproductbuilder.js
// Purpose: Replace the ugly default CPB summary with the clean one Gunnar paid for

(function($) {
    'use strict';

    function rebuildCustomSummary() {
        const $root = $('#product-builder');
        if (!$root.is('[data-custom-summary]')) return;

        $('.cbpc-summary-total').remove();

        const $old = $root.find('.cpb-selection-summary');
        if (!$old.length) return;

        const $container = $('<div class="cbpc-summary-total">');
        const $title = $('<div class="cbpc-summary-total__title">').text(
            $old.find('.cpb-selection-summary-total-label').text()
        );
        const $price = $('<div class="cbpc-summary-total__price">').text(
            $old.find('.cpb-selection-summary-total-price').text()
        );
        $container.append($title, $price);

        const $summary = $('<div class="cbpc-summary">');

        $old.find('.cpb-summary-content-wrapper').each(function() {
            const panelTitle = $(this).find('.cpb-selection-summary-list-item-panel').text().trim();
            if (!panelTitle) return;

            const $panel = $('<div class="cbpc-summary-panel">');
            $panel.append(`<div class="cbpc-summary-panel__title">${panelTitle}</div>`);

            let hasItems = false;
            $(this).find('.cpb-summary-list-item-category').each(function() {
                const text = $(this).find('.cpb-selection-summary-list-item-category-value').text().trim();
                if (!text) return;

                // Find corresponding checked option + its quantity
                const $cb = $(`.cpb-checkbox-input:checked[data-label*="${text.split(' × ')[0]}"]`);
                if ($cb.length) {
                    const optionId = $cb.closest('[data-option-id]').attr('data-option-id');
                    const qty = optionId && window.inlineCounters && window.inlineCounters[optionId]
                        ? parseInt(window.inlineCounters[optionId].querySelector('.my-qty-input').value) || 1
                        : 1;

                    const line = qty > 1 ? `${text} × ${qty}` : text;
                    $panel.append(`<div class="cbpc-summary-panel__value">${line}</div>`);
                    hasItems = true;
                }
            });

            if (hasItems) $summary.append($panel);
        });

        $container.prepend($summary);
        $old.after($container).hide();
    }

    // Make inline counters globally accessible so summary can read them
    window.inlineCounters = window.inlineCounters || {};

    $(document).on('CPB_ON_PRODUCT_MOUNTED CPB_ON_UPDATE_CURRENT_TAB CPB_ON_OPTIONS_UPDATE change input', 'input[data-testid="counter-input"], .my-qty-input', rebuildCustomSummary);

    // Initial build
    $(document).ready(function() {
        setTimeout(rebuildCustomSummary, 1500);
    });

})(jQuery);